module.exports = __webpack_public_path__ + "static/purchase_portal2-27efa489516fb2b714e7573be747beac.png";